/* 邀请奖励 */
export const awardList = [
  {
    invite_total: 1,
    download_total: 4,
    day_download: 2,
    award: '无',
    coupon_class:'coupon-no'
  },
  {
    invite_total: 3,
    download_total: 10,
    day_download: 4,
    award: '5元优惠券',
    coupon_class:'coupon-5'
  },
  {
    invite_total: 10,
    download_total: 30,
    day_download: 10,
    award: '10元优惠券',
    coupon_class:'coupon-10'
  },
  {
    invite_total: 30,
    download_total: 100,
    day_download: 15,
    award: '商用包季VIP',
    coupon_class:'coupon-30'
  },
  {
    invite_total: 100,
    download_total: 400,
    day_download: 20,
    award: '商用包年VIP',
    coupon_class:'coupon-100'
  },

]

/* 活动步骤 */
export const ACT_STEP = [
  '向好友分享你专属链接',
  '好友打开你专属链接完成注册',
  '注册成功后奖励自动到账',
]

